module.exports = __webpack_public_path__ + "static/img/puji11.29e8f30d.png";